<!--suppress XmlDuplicatedId -->
<script>
	export let checked = false;
	export let id = undefined;
	export let name = '';
	export let text = '';
	export let className = '';
	export let size = '6';
	export let disabled = false;
	export let center = false;
	export let hidden = false;
	export let reverse = false;
</script>

<!-- svelte-ignore a11y-label-has-associated-control -->
{#if !hidden}
	<label class="relative flex items-center justify-start" class:justify-start={!center} class:justify-center={center}>
		{#if reverse}
			<span class="mr-2 select-none {className}">{text}</span>
		{/if}
		<span
			class="flex items-center justify-center flex-shrink-0 w-{size} h-{size}
    border-2 border-gray-400 rounded bg-white {disabled ? 'opacity-50' : ''}"
		>
			<input {disabled} {name} id={id ?? name} type="checkbox" class="absolute opacity-0" bind:checked on:change />
			<svg class:hidden={!checked} class="w-4 h-4 text-primary pointer-events-none fill-current" viewBox="0 0 20 20">
				<path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
			</svg>
		</span>
		{#if !reverse}
			<span class="ml-2 select-none {className}">{text}</span>
		{/if}
	</label>
{:else}
	<input {disabled} {name} id={id ?? name} type="checkbox" class="absolute opacity-0" bind:checked on:change />
{/if}
